import { useDataProvider } from "ra-core";
import type { IntegrationDataProvider, IntegrationMethods } from "./types";

/** The dataProvider's integration methods (FakeRest in demo/tests, RPCs on Supabase). */
export function useIntegrationApi(): IntegrationMethods {
  const dp = useDataProvider<IntegrationDataProvider>();
  if (typeof dp.granolaAddManualNote !== "function")
    throw new Error("IntegrationMethods missing on the dataProvider");
  return dp;
}
